const stateBox = "_35ssimd318";
const button = "_35sbtd4uum";
const label = "_35sl9bvt9c";
const selectedValue = "_35ss1rlj8pp";
const chevron = "_35sc1fwk0zu";
const dropdown = "_35sdid9cjz";

export { button, chevron, dropdown, label, selectedValue, stateBox };
import "./input.word-dropdown.style.linaria.module.css";
//# sourceMappingURL=input.word-dropdown.style.js.map
